import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import CatalogoCuentasPresu from '../../catalogos/catalogoCuentasPresupuestarias';

export const AgregarCuentas = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [montocuenta, setMontocuenta] = useState(0.00);
    const [mostrar4, setMostrar4] = useState(false);
    const [val, setVal] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('00');
    const [valor6, setValor6] = useState('000');
    const [valor7, setValor7] = useState('00');
    const [valor8, setValor8] = useState('00');
    const [valor9, setValor9] = useState('00');
    const [valor10, setValor10] = useState('0000');

    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [values, setValues] = useState({
        idcuenta: "",
        auxiliar: "",
        descripcionaux: "",
        idcategoriaprogramatica: "",
        idpuc: "",
        puc: "",
        categoria: "",
        disponibilidad: 0.00,
        montoinicial: 0.00,
        tipopartida: "",

    });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtTipoPartidai = useRef();
    const txtTipoPartidag = useRef();
    const txtPuc = useRef();
    const txtCat = useRef();
    const txtDescriaux = useRef();
    const txtDescriclas = useRef();
    const txtMonto = useRef();
    const txtDisponible = useRef();
    const txt1 = useRef();
    const txt2 = useRef();
    const txt3 = useRef();
    const txt4 = useRef();
    const txt5 = useRef();
    const txt6 = useRef();
    const txt7 = useRef();
    const txt8 = useRef();
    const txt9 = useRef();
    const txt10 = useRef();

    const onChange = (e) => {
        let monto = txtMonto.current.value;
        if (e.target.name === 'monto') {
            console.log(monto)
            if (montocuenta < e.target.value) {
                console.log('pase por aqui')
                /* setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Traslado Registrado Correctamente', icono: 'exito' }); */
            }
        }
    };

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setValues({
            idcuenta: "",
            auxiliar: "",
            descripcionaux: "",
            idcategoriaprogramatica: "",
            idpuc: "",
            puc: "",
            categoria: "",
            disponibilidad: 0.00,
            montoinicial: 0.00,
            tipopartida: "",

        });
        setActivate(false);
        setValor1('00');
        setValor2('00');
        setValor3('00');
        setValor4('00');
        setValor5('00');
        setValor6('000');
        setValor7('00');
        setValor8('00');
        setValor9('00');
        setValor10('0000');
        setActivo(true);
    };


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {

            setValues({ ...values, [event.target.name]: event.target.value });

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }

        if (event.target.id === 'monto') {
            let montoval = event.target.value.trim().replace(/\./g, '').replace(',', '.');
            let montopresu = montocuenta.trim().replace(/\./g, '').replace(',', '.');
            if (props.esaumento !== true) {
                if (parseFloat(montoval) > parseFloat(montopresu)) {
                    setActivo(true);
                    setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'El Monto no debe ser Mayor a la Disponibilidad', icono: 'error' });
                    txtMonto.current.value = '';
                    return;
                } else {
                    setActivo(false);
                }
            } else {
                setActivo(false);
            }
            if (event.which === 13) {
                setTimeout(() => {
                    btnAcepta.current.focus();
                }, 200);
                
            }
            
        }

             
        // Devuelve el número formateado
        let e = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        return formatMoneda(e)
    };


  
    const handleAceptaClasPresupuestaria = (cuenta, descripcion, auxiliar, disponible, idcuenta, idcat, idpuc, descriaux) => {
        setMostrar4(false);
        console.log(cuenta, descripcion, auxiliar, disponible, idcuenta, idcat, idpuc, descriaux)
        if (props.cuentas && props.cuentas.length > 0){
            for (let i = 0; i < props.cuentas.length; i++) {
                if(props.cuentas[i].idcuenta === idcuenta){
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'LA CUENTA YA EXISTE', icono: 'informacion' });
                    return;
                }
            }
        }
        txtDescriclas.current.value = descripcion.trim();
        setValor1(cuenta.substring(0, 2));
        setValor2(cuenta.substring(2, 4));
        setValor3(cuenta.substring(4, 6));
        setValor4(cuenta.substring(6, 8));
        setValor5(cuenta.substring(8, 10));
        setValor6(cuenta.substring(10, 13));
        setValor7(cuenta.substring(13, 15));
        setValor8(cuenta.substring(15, 17));
        setValor9(cuenta.substring(17, 19));
        setValor10(auxiliar.trim());
        txtId.current.value = idcuenta;
        txtPuc.current.value = idpuc;
        txtCat.current.value = idcat;
        txtDescriaux.current.value = descriaux;
        txtDisponible.current.value = formatMoneda(disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setMontocuenta(formatMoneda(disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2));

    }
    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarClassPresupuestaria = () => {
        blanquear();
        var datos = [];
        datos.push({
            uno: valor1,
            dos: valor2,
            tres: valor3,
            cuatro: valor4,
            cinco: valor5,
            seis: valor6,
            siete: valor7,
            ocho: valor8,
            nueve: valor9,
            auxiliar: valor10,
            descripcion: txtDescriclas.current.value,
            monto: txtMonto.current.value.trim().replace(/\./g, '').replace(',', '.'),
            disponible: txtDisponible.current.value.trim().replace(/\./g, '').replace(',', '.'),
            idcuenta: txtId.current.value,
            idcat: txtCat.current.value,
            idpuc: txtPuc.current.value,
            descripcionaux: txtDescriaux.current.value.trim()
        })
        console.log(datos)
        props.onDatos(datos);
        props.onHideCancela();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion !== 1) {
                    setValues(props.presu);
                } else {
                    /* txtTipoPartidag.current.checked = false;
                    txtTipoPartidai.current.checked = false;
                    txtDescriclas.current.value = "";
                    txt6.current.value = "";
                    txt7.current.value = "";
                    txt8.current.value = "";
                    txt9.current.value = ""; */
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Selección de Cuenta.' : operacion === 2 ? 'Editar Presupuesto.' : operacion === 3 ? 'Eliminar Presupuesto.' : 'Consultar Presupuesto.'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoCuentasPresu
                    show={mostrar4}
                    val={val}
                    vals={val2}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
                />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>

                    <input type='hidden' ref={txtId} />
                    <input type='hidden' ref={txtPuc} />
                    <input type='hidden' ref={txtCat} />
                    <input type='hidden' ref={txtDescriaux} />


                    <div className='col-md-12 py-2'></div>

                    <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto" >Cuenta Presupuestaria</legend>

                        <div className='container row m-0 d-flex justify-content-center col-12 mx-auto px-0'>

                            <div className='mb-2'></div>

                            <div className='col-md-12 m-0 px-0'>
                                <table className="table">
                                    <thead>
                                        <tr className='text-center'>
                                            <th scope="col">Sector</th>

                                            <th scope="col">Prog</th>

                                            <th scope="col">SubPr</th>

                                            <th scope="col">Proy</th>

                                            <th scope="col">Act</th>

                                            <th scope="col">Part</th>

                                            <th scope="col">Gen</th>

                                            <th scope="col">Espec</th>

                                            <th scope="col">SubEsp</th>

                                            <th scope="col">Aux</th>
                                        </tr>
                                    </thead>
                                    <tbody className='table-bordered'>
                                        <tr className='text-center'>
                                            <td>{valor1}</td>

                                            <td>{valor2}</td>

                                            <td>{valor3}</td>

                                            <td>{valor4}</td>

                                            <td>{valor5}</td>

                                            <td>{valor6}</td>

                                            <td>{valor7}</td>

                                            <td>{valor8}</td>

                                            <td>{valor9}</td>

                                            <td>{valor10}</td>
                                            <td><button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className='col-sm-5 row m-0 px-0'>
                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Sector:</label>
                                        <input type="text" disabled={true} maxLength="3" name='uno' ref={txt1} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(0, 3) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Prog:</label>
                                        <input type="text" disabled={true} maxLength="2" name='dos' ref={txt2} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(3, 5) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">SubPr:</label>
                                        <input type="text" disabled={true} maxLength="2" name='tres' ref={txt3} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(5, 7) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Proy:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt4} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                            </div> */}

                            {/*  <div className='col-sm-2 row m-0 px-0'>

                                <div className='col-sm-5 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Act:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt5} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-7 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Part:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt6} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                            </div> */}

                            {/* <div className='col-sm-5 row m-0 px-0'>

                                <div className='col-sm-2 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Gen:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt7} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Espec:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt8} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-3 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">SubEsp:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt9} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    </div>
                                </div>

                                <div className='col-sm-4 mb-2 px-1'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Aux:</label>
                                        <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt10} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                        <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button>
                                    </div>
                                </div>
                            </div> */}

                        </div>

                        <div className='col-sm-8 px-0'>
                            <div className='col-sm-12 mb-2 px-0'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                                    <textarea type="text" className="form-control text-uppercase" style={{ height: '60px' }} disabled={true} ref={txtDescriclas} defaultValue={props.claspre ? props.claspre.descripcion : ''} placeholder="Descripción del Clasificador Presupuestario" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-4 px-0'>
                            <div className='col-sm-12 mb-1 ml-auto px-1 ml-auto'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Disponibilidad:</label>
                                    <input type="text" autoComplete='off' className="form-control text-right" disabled={true} ref={txtDisponible} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                                </div>
                            </div>
                            <div className='col-sm-10 mb-1 ml-auto px-1'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Monto:</label>
                                    <input type="text" autoComplete='off' className="form-control text-right" disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} ref={txtMonto} defaultValue={values && values.montoinicial ? formatMoneda(values.montoinicial.toString().replace(',', '').replace('.', ','), ',', '.', 2) : ''} onBlur={handleInputMontoChange} onKeyUp={handleInputMontoChange} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                                </div>
                            </div>
                        </div>


                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={seleccionarClassPresupuestaria} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}